import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  selectBuyerProjectManagerUpdating,
  selectOperatorProjectManagerUpdating,
} from './survey-management.selectors';

@Injectable({ providedIn: 'root' })
export class SurveyManagementSelectorsFacade {
  private readonly _store = inject(Store);

  public readonly buyerProjectManagerUpdating = this._store.selectSignal(
    selectBuyerProjectManagerUpdating,
  );
  public readonly operatorProjectManagerUpdating = this._store.selectSignal(
    selectOperatorProjectManagerUpdating,
  );
}
